import React from 'react'
import './AgentAccordionHeader.css'
import { IconCircleFilled } from '@tabler/icons-react'
import classNames from 'classnames'

export const AlertCategory = (props) => {
  const { count, name } = props
  const categoryText = `${count} ${name}`
  const status = count ? props.color : 'neutral'

  return (
    <div className="alert-category">
      <div className="alert-category-icon">
        <IconCircleFilled size={8} className={classNames('alert-dot', `fill-${status}`)} />
      </div>
      <div className="alert-category-name">{categoryText}</div>
    </div>
  )
}
